import { useMutation } from "@tanstack/react-query";
import { sendB2bRequest } from "./B2bRequestApi";

export interface B2bRequest {
  readonly name: string;
  readonly company: string;
  readonly nip: string;
  readonly email: string;
  readonly phone: string;
  readonly token: string;
}

export const useSendB2bRequest = () => {
  const updateMutation = useMutation({
    mutationFn: (request: B2bRequest) => sendB2bRequest(request),
  });

  return {
    sendB2bRequest: updateMutation.mutateAsync,
  };
};
